module.exports = __webpack_public_path__ + "img/loading.fba1eab4.gif";